import { SidebarProvider } from "@/components/ui/sidebar";
import Header from "./Header";
import AdminSidebar from "./Sidebar";
import SubscriptionManagement from "./SubscriptionManagement";

const SubscriptionPage = () => {
  // merry christmass
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
        <AdminSidebar onSectionChange={() => {}} />
        <div className="flex flex-col flex-1 h-full">
          <Header />
          <main className="flex-1 overflow-y-auto p-3 sm:p-6">
            <div className="space-y-6">
              <h1 className="text-2xl font-bold text-gray-900">Subscription Management</h1>
              <SubscriptionManagement />
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default SubscriptionPage;
